import siteData from "../data/siteData.json";
import "./Projects.css";
import { useNavigate } from "react-router-dom";


export default function Projects() {

  const navigate = useNavigate();


  return (
    <section id="projects" className="projects-section">
      <div className="projects-top">
        <h2 className="projects-title">Our Projects</h2>
        <button
            className="view-all-btn"
            onClick={() => navigate("/projects")}
        >
            View All →
        </button>

      </div>

      <div className="projects-slider">
        {siteData.projects.map((project, index) => (
          <div className="project-card" key={index}>
            
            <div className="project-img-box">
              <img src={project.image} alt={project.name} />
            </div>

            <h3 className="project-name">{project.name}</h3>
            <p className="project-location">{project.location}</p>

            <button className="know-more-btn">
              Know More
            </button>

          </div>
        ))}
      </div>
    </section>
  );
}
